import { useTranslation } from 'react-i18next';
import styles from '../../Components/Bookings/Bookings.module.css';

export default function CheckOutItem({ Carts }) {
  const { t, i18n } = useTranslation();

  return (
    <div>
      {Carts.length > 0 ? (
        Carts.map((cart, index) => (
          // Move `key` prop to the outermost div for proper list rendering
          <div key={index} className={`mx-auto ${styles.box} w-75 my-3 p-2`}>
            <div className="my-3">
              <div className={`${styles.titleBill} mt-1 ${styles.txt_start}`}>
                {/* Conditionally render itm_nam or itm_enm based on the language */}
                {i18n.language === 'ar' ? cart?.itm_nam?.trim() : cart?.itm_enm?.trim()}
              </div>

              <div className={`m-2 ${styles.smallFont}`}>
                {t("serviceProvider")}: { i18n.language === 'ar' ? cart?.emp_nam.trim() : cart?.emp_enm .trim()}
              </div>
              <div className={`m-2 ${styles.smallFont}`}>
                {t("branch")}: {i18n.language === 'ar' ? cart?.brn_nam.trim() : cart?.brn_enm.trim()}
              </div>
              <div className={`m-2 ${styles.smallFont}`}>
                {t("date")}: {cart?.date?.trim()}
              </div>
              <div className="m-2 d-flex justify-content-between">
                <div className={`${styles.smallFont}`}>
                  {t("time")}: {cart?.time?.trim()}
                </div>
                <div className={styles?.totalPrice}>
                  {Number(cart?.itm_price.trim())?.toFixed(2)} {t("rs")}
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div>{t("No items in the cart.")}</div>
      )}
    </div>
  );
}
